// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share of cases processed without errors out of all cases successfully processed by turian.`)
};

const en_us2_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share of cases processed without errors out of all cases successfully processed by turian.`)
};

const de_de2_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteil der fehlerfrei verarbeiteten Vorgänge an allen von turian verarbeiteten Vorgängen.`)
};

const en_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share of cases processed without errors out of all cases successfully processed by turian.`)
};

const de_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteil der fehlerfrei verarbeiteten Vorgänge an allen von turian verarbeiteten Vorgängen.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1", locale)
	if (locale === "en-GB") return en_gb2_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1(inputs)
	if (locale === "en-US") return en_us2_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1(inputs)
	if (locale === "de-DE") return de_de2_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1(inputs)
	if (locale === "en") return en_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1(inputs)
	return de_share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1(inputs)
};
export { share_of_cases_processed_without_errors_out_of_all_cases_successfully_processed_by_turian_1 as "Share of cases processed without errors out of all cases successfully processed by turian." }